module.exports = __webpack_public_path__ + "static/img/ls5.3786937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls5.png
// module id = M/iC
// module chunks = 12